import { useCallback } from 'react'
import useAlert from '../../../components/Alert/hooks/useAlert'
import getPartner from '../repository/getPartner'

const usePaymentInfo = () => {
  const { alertError } = useAlert()

  const fetchTipaltiUrl = useCallback(async (): Promise<string> => {
    const result = await getPartner()

    if ('error' in result) {
      alertError('Failed to load the Payment Info')
      return ''
    }

    return result.tipalti_url
  }, [alertError])

  return {
    fetchTipaltiUrl
  }
}

export default usePaymentInfo
